import { get } from 'lodash';

// the value represents the index of the color array in Mantine
const accentColorMap: Record<string, number> = {
	'--border-brand-default': 5,
	'--border-brand-bold': 8,
	'--icon-brand-default': 5,
	'--icon-brand-bold': 8,
	'--text-brand-default': 5,
	'--text-brand-bold': 8,
	'--surface-brand-bold-pressed': 7,
	'--surface-brand-bold-hovered': 6,
	'--surface-brand-bold-default': 5,
	'--surface-brand-pressed': 2,
	'--surface-brand-hovered': 1,
	'--surface-brand-default': 0,
};

export const setAccentColor = (accentColors: string[]) => {
	Object.entries(accentColorMap).forEach(([key, value]) => {
		document.documentElement.style.setProperty(key, get(accentColors, value));
	});
};
